import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type {
  Interlocuzione,
  InterlocuzioneCreate,
  InterlocuzioneUpdate,
} from "@/types/api";

export function useAdminConversazioni() {
  return useQuery({
    queryKey: ["admin-conversazioni"],
    queryFn: () => apiFetch<Interlocuzione[]>("/api/v1/admin/conversazioni"),
    staleTime: 30_000,
  });
}

export function useCreateConversazione() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: InterlocuzioneCreate) =>
      apiFetch<Interlocuzione>("/api/v1/admin/conversazioni", {
        method: "POST",
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["admin-conversazioni"] });
      qc.invalidateQueries({ queryKey: ["conversazioni"] });
    },
  });
}

interface UpdateArgs {
  id: string;
  body: InterlocuzioneUpdate;
}

export function useUpdateConversazione() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: UpdateArgs) =>
      apiFetch<Interlocuzione>(`/api/v1/admin/conversazioni/${id}`, {
        method: "PATCH",
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["admin-conversazioni"] });
      qc.invalidateQueries({ queryKey: ["conversazioni"] });
    },
  });
}

export function useDeleteConversazione() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      apiFetch<void>(`/api/v1/admin/conversazioni/${id}`, { method: "DELETE" }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["admin-conversazioni"] });
      qc.invalidateQueries({ queryKey: ["conversazioni"] });
    },
  });
}
